export interface ApiErrorOptions {
  details?: Record<string, unknown>;
  requestId?: string;
  cause?: unknown;
}

/** Any failure talking to the API: an error envelope, a bad response or a network failure. */
export class ApiError extends Error {
  readonly code: string;
  /** HTTP status; 0 when the request never reached the server. */
  readonly status: number;
  readonly details: Record<string, unknown> | undefined;
  readonly requestId: string | undefined;

  constructor(code: string, message: string, status: number, options: ApiErrorOptions = {}) {
    super(message, options.cause === undefined ? undefined : { cause: options.cause });
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    this.details = options.details;
    this.requestId = options.requestId;
  }
}

export function isApiError(value: unknown): value is ApiError {
  return value instanceof ApiError;
}

/** A message safe to show a person. */
export function errorMessage(value: unknown): string {
  if (value instanceof Error && value.message) return value.message;
  return 'Something went wrong. Please try again.';
}
